import {Controller} from "@hotwired/stimulus"

// The sidebar form is server-rendered from the applied request, and it sits
// outside the permanent filter list, so each visit starts from what the report
// is actually using. Later choices that have not been applied show in a banner
// above the button, counted per filter.
const IGNORED_FIELDS = new Set(["authenticity_token", "argument_request"])

export default class extends Controller {
  static targets = ["notice", "summary", "apply"]

  connect() {
    this.applied = this.values()
    this.onEdit = () => this.refresh()
    this.element.addEventListener("input", this.onEdit)
    this.element.addEventListener("change", this.onEdit)
    this.refresh()
  }

  disconnect() {
    if (!this.onEdit) return
    this.element.removeEventListener("input", this.onEdit)
    this.element.removeEventListener("change", this.onEdit)
  }

  refresh() {
    const count = this.changedCount()
    const pending = count > 0
    const text = `${count} filter${count === 1 ? "" : "s"} not applied`
    if (this.hasNoticeTarget) {
      this.noticeTarget.classList.toggle("hidden", !pending)
      this.noticeTarget.classList.toggle("flex", pending)
    }
    if (this.hasSummaryTarget) this.summaryTarget.textContent = text
    if (!this.hasApplyTarget) return
    if (pending) this.applyTarget.setAttribute("aria-label", `Apply filters, ${text}`)
    else this.applyTarget.removeAttribute("aria-label")
  }

  // Filters whose picked values differ from what the report is using.
  changedCount() {
    const current = this.values()
    const names = new Set([...this.applied.keys(), ...current.keys()])
    let count = 0
    for (const name of names) {
      if ((this.applied.get(name) || "") !== (current.get(name) || "")) count++
    }
    return count
  }

  // filter name (without the [] of multi-selects) => its sorted values
  values() {
    const byName = new Map()
    for (const [key, value] of new FormData(this.element).entries()) {
      if (IGNORED_FIELDS.has(key)) continue
      const name = key.replace(/\[\]$/, "")
      if (!byName.has(name)) byName.set(name, [])
      if (value !== "") byName.get(name).push(String(value))
    }
    const signature = new Map()
    for (const [name, list] of byName) signature.set(name, list.sort().join("\n"))
    return signature
  }
}
